import React from "react";
import { Flex, Grid, Icon, Text } from "@chakra-ui/react";
import { BackgroundCheckItemProps } from "./PrincipalOverview.types";
import { NotesPopover } from "./NotesPopover";
import { CheckCircleIcon } from "../../../../icons";

export const BackgroundCheckItem: React.FC<BackgroundCheckItemProps> = ({
  title,
  text,
  years,
  notes,
  ...rest
}) => {
  return (
    <Grid
      _last={{ borderBottomWidth: "0px" }}
      templateColumns={"6fr 5fr"}
      width="100%"
      p="20px"
      bg={"bg.white"}
      alignItems="center"
      borderBottomWidth="1px"
      borderBottomColor="border.input"
      {...rest}
    >
      <Text textStyle="bodySmall" fontWeight="500">
        {title}
      </Text>
      <Flex alignItems="center" justifyContent="flex-end">
        <Text textStyle="bodySmall" color="text.grey" width="20px">
          {text}
        </Text>

        <Text ml="50px" textStyle="bodySmall" color="text.grey" width="60px">
          {years} {years !== 1 ? " Years" : "Year"}
        </Text>
        {text !== 0 && notes && <NotesPopover notes={notes} />}
        {(!notes || notes.length < 0) && (
          <Icon
            ml="50px"
            as={CheckCircleIcon}
            color={text === 0 ? "brand.main" : "icons.grey"}
            boxSize="24px"
          />
        )}
      </Flex>
    </Grid>
  );
};
